export default __webpack_public_path__ + "static/media/mhvaletinglogo.386c21b7.png";